import { useMemo } from "react";
import type { SWRConfiguration, SWRResponse } from "swr";
import useApi from "../../api/useApi";
import {
    GetSearchResultsRequest,
    GetSearchResultsResponse,
    type IReturn,
} from "src/api/Tmd.dtos";

const getData = (
    response?: SWRResponse<
        GetSearchResultsResponse,
        GetSearchResultsResponse
    >,
) => response?.data?.results;
const getError = (
    response?: SWRResponse<
        GetSearchResultsResponse,
        GetSearchResultsResponse
    >,
) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (
    response?: SWRResponse<
        GetSearchResultsResponse,
        GetSearchResultsResponse
    >,
) => ({});

const useSearch = (
    query?: string | null | undefined,
    configuration?:
        | SWRConfiguration<
              GetSearchResultsResponse,
              GetSearchResultsResponse
          >
        | null
        | undefined,
) => {
    const getRequest = useMemo(
        () => {
            if (!query) {
                return undefined;
            }

            return (): IReturn<GetSearchResultsResponse> =>
                new GetSearchResultsRequest({ searchFor: query })
        },
        [query],
    );

    return useApi("get", getRequest, { getData, getError, getAdditionalState }, configuration);
};

export default useSearch;
